import React, { useEffect, useState } from 'react';

import { PlaidModalLoader } from '@views/Payments/PlaidModalLoader';
import { usePlaidOnSuccess } from '@hooks/usePlaidOnSuccess';
import { PaymentProcessingModal } from '@views/Payments/PaymentProcessingModal';
import { formatPriceWithCents } from '@utils/currency';

export const OAuthLoader = ({ basepath }) => {
  const [linkToken, setLinkToken] = useState('');
  const [chargeAmount, setChargeAmount] = useState({
    amount: 0,
    currency: 'USD',
  });
  const [orderId, setOrderId] = useState('');
  const [displayProcessingModal, setDisplayProcessingModal] = useState(false);

  const oauthObject = localStorage.getItem('plaidOauthObject');

  useEffect(() => {
    if (oauthObject != null) {
      setLinkToken(JSON.parse(oauthObject).linkToken);
      setChargeAmount(JSON.parse(oauthObject).amount);
      setOrderId(JSON.parse(oauthObject).orderId);
    }
  }, [oauthObject]);

  const onPlaidSuccess = usePlaidOnSuccess(
    true,
    basepath,
    orderId,
    chargeAmount,
    setDisplayProcessingModal
  );

  return (
    <>
      {linkToken && chargeAmount.currency === 'USD' && (
        <PlaidModalLoader
          isOauth
          linkToken={linkToken}
          onPlaidSuccess={onPlaidSuccess}
          basepath={basepath}
          orderId={orderId}
        />
      )}
      <PaymentProcessingModal
        open={displayProcessingModal}
        amountChargedString={formatPriceWithCents(
          chargeAmount?.amount,
          chargeAmount?.currency
        )}
      />
    </>
  );
};
